import memoizeOne from 'memoize-one';
import getMeta from '@atlassian/jira-get-meta';

export const getCloudId = memoizeOne((): string | null => getMeta('ajs-cloud-id'));
